(() => {
  if (document.documentElement.dataset.bookPreviewReady) return;
  document.documentElement.dataset.bookPreviewReady = 'true';

  function embedUrl(href) {
    let source;
    try { source = new URL(href); } catch { return null; }
    if (source.protocol !== 'https:' || source.username || source.password || source.port) return null;
    if (source.hostname === 'issuu.com' || source.hostname === 'www.issuu.com') {
      const match = source.pathname.match(/^\/([a-z0-9_-]+)\/docs\/([a-z0-9_-]+)\/?$/i);
      if (!match) return null;
      const embed = new URL('https://e.issuu.com/embed.html');
      embed.searchParams.set('u', match[1]);
      embed.searchParams.set('d', match[2]);
      return embed.href;
    }
    return null;
  }

  if (typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
  let dialog, frame, title, fallback, opener, previousOverflow;
  function createDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'book-preview';
    dialog.setAttribute('aria-labelledby', 'book-preview-title');
    dialog.innerHTML = '<div class="book-preview__panel"><header class="book-preview__header"><h2 id="book-preview-title">Bla i boka</h2><button class="book-preview__close" type="button" aria-label="Lukk lesarpr\u00f8va" autofocus>\u00d7</button></header><iframe class="book-preview__frame" title="Bla i boka" allow="fullscreen" allowfullscreen sandbox="allow-scripts allow-same-origin allow-popups allow-presentation" referrerpolicy="strict-origin-when-cross-origin"></iframe><footer class="book-preview__footer">F\u00e5r du ikkje opp bla-i-boka? <a target="_blank" rel="noopener noreferrer">Opne i ny fane</a></footer></div>';
    document.body.append(dialog);
    frame = dialog.querySelector('iframe');
    title = dialog.querySelector('h2');
    fallback = dialog.querySelector('a');
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      const r = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) dialog.close();
    });
    dialog.addEventListener('close', () => {
      frame.removeAttribute('src');
      document.documentElement.style.overflow = previousOverflow;
      if (opener && opener.isConnected) opener.focus({preventScroll: true});
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[data-book-preview]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const embed = embedUrl(link.href);
    if (!embed) return; // Unsupported sources and no-JS keep the existing link.
    if (!dialog) createDialog();
    if (dialog.open) return;
    event.preventDefault();
    opener = link;
    title.textContent = 'Bla i boka: ' + (link.dataset.bookTitle || 'Lesarpr\u00f8ve');
    frame.title = title.textContent;
    fallback.href = link.href;
    previousOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    frame.src = embed; // Contact the reader only after the visitor opens it.
  });
  function labelLinks() {
    document.querySelectorAll('a[data-book-preview]').forEach(link => {
      if (!embedUrl(link.href)) return;
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-label', 'Bla i boka: ' + (link.dataset.bookTitle || 'Lesarpr\u00f8ve'));
    });
  }
  labelLinks();
  document.addEventListener('shopify:section:load', labelLinks);
})();
